// @ts-nocheck
import {
    OrderDetailsStatusStyles,
    statusStyles,
} from "@insite/content-library/Widgets/OrderDetails/OrderDetailsStatus";
import { infoProps } from "@store/Themes/common/props/info";

Object.assign<OrderDetailsStatusStyles>(statusStyles, {
    wrapper: {},
    titleText: infoProps.label,
    status: infoProps.value,
});
